<!--
 * @FilePath: CounterTree.vue
 * @Author: Elie
 * @Date: 2023-08-25 18:57:30
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-21 16:34:42
 * Copyright: 2023 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion:
-->
<template>
  <div style="display: inline-block; width: 100%">
    <!-- 替换展示框和搜索框的策略 -->
    <el-input class="selectClass" :placeholder="inputPlaceholder || $t('app.pleaseSelectCounter')" v-model="lstUserName" v-popover:choseAgentPopover
      v-if="lstUserName && lstUserName != ''" readonly>
      <span class="el-input__suffix" slot="suffix">
        <span class="el-input__suffix-inner">
          <i class="el-select__caret el-input__icon el-icon-arrow-up" :class="{
            'is-reverse': showCounterDropDown
          }"></i>
        </span>
      </span>
    </el-input>
    <el-input class="selectClass" :placeholder="inputPlaceholder || $t('app.pleaseSelectCounter')" v-model="filterText" v-popover:choseAgentPopover v-else>
      <span class="el-input__suffix" slot="suffix">
        <span class="el-input__suffix-inner">
          <i class="el-select__caret el-input__icon el-icon-arrow-down" :class="{
            'is-reverse': showCounterDropDown
          }"></i>
        </span>
      </span>
    </el-input>

    <el-popover popper-class="agent-popover" placement="bottom-start" height="300" ref="choseAgentPopover" trigger="click"
      @show="showCounterPopover" @hide="hideCounterPopover" :visible-arrow="false">
      <div>
        <!-- <el-input class="keyword-search" :placeholder="searchPlaceholder">
        </el-input> -->
        <el-tree :data="dataList" show-checkbox @check-change="handleCheckChange" node-key="id" height="100px"
          ref="counterTree" :filter-node-method="filterNode">
        </el-tree>
      </div>
    </el-popover>
  </div>
</template>

<script>
import { getCounterListById } from "@/api/SquirrelSettlement";
export default {
  data() {
    return {
      filterAgentTextClass: "",
      agentTreeData: [],
      showCounterDropDown: false,
      lstUserName: "",
      lstUserId: [],
      radios: [],
      dataList: [],
      filterText: ""
    };
  },
  props: {
    isShowLabel: {
      type: Boolean,
      default: false
    },
    inputPlaceholder: {
      type: String,
      default: ""
    },
    isSingleChoice: {
      type: Boolean,
      default: false
    },
    doClear: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    filterText(val) {
      this.$refs.counterTree.filter(val);
    },
    doClear(newVal, oldVal) {
      this.clearSelect();
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleCheckChange(data) {
      console.log(data);
    },
    async initData() {

      let { data } = await getCounterListById()
      console.log('data', data);
      let result = [];
      result = data.map(e => {
        return {
          id: e.counterNo,
          label: e.counterName,
          children: e.childs
        };
      });

      this.dataList = [
        {
          id: 0,
          label: this.$t('app.auto_640_2494517e'),
          children: result
        }
      ];
    },
    showCounterPopover() {
      this.showCounterDropDown = true;
    },
    hideCounterPopover() {
      this.showCounterDropDown = false;
      this.lstUserId = []; //置空一下
      this.lstUserName = "";
      let selectPeopleName = [];
      let selectIdArr = this.$refs.counterTree.getCheckedKeys();
      console.log(this.$refs.counterTree.getCheckedKeys());
      selectIdArr = selectIdArr.filter(e => e !== 0); //把全选的节点去掉
      let selectNodeArr = this.$refs.counterTree.getCheckedNodes();
      selectNodeArr = selectNodeArr.filter(e => e.id !== 0); //把全选的节点去掉
     
      console.log(selectNodeArr);
      if (selectNodeArr.length > 0) {
        selectNodeArr.map(item => {
          selectPeopleName.push(item["label"]);
        });
        this.lstUserName = selectPeopleName.join(",");
        this.lstUserId = selectIdArr;
        console.log(this.lstUserId);
        this.$emit("input", this.lstUserId); //必须在前面
        this.$emit("select", this.lstUserId);
        this.filterText = "";
      } else {
        this.lstUserName = "";
        this.lstUserId = [];
        this.filterText = "";
        this.$emit("input", []); //必须在前面
        this.$emit("select", []); //为了清空
      }
    },
    clearSelect() {
      this.$refs.counterTree.setCheckedNodes([]);
      this.lstUserName = "";
    }

  },
  mounted() {
    this.initData();
  }
};
</script>

<style lang="scss" scoped>
.is-reverse {
  transform: rotate(-180deg);
}

.selectClass {
  width: 100%;

  :deep(.el-input__inner) {
    height: 32px;
  }
}
</style>

<style lang="scss">
.agent-popover {
  max-height: 300px;
  // width: 10%;
  overflow-y: auto;
}
</style>

